export default __webpack_public_path__ + "static/media/deposit-success.8407394b.svg";